/* ==========================================================================
   Stealth PDP V3 (round 2 item 10, sp2-pdp). Spec: Strategy/2026-10/pdp-redesign/PDP-Redesign-Spec-2026-10-03.md
   Runs on [data-sp-pdp3] (snippets/sp-pdp.liquid). Impulse's product engine (theme.js Product, Variants,
   VariantAvailability, AjaxProduct) keeps owning variant state and the ajax add; this file only refines the page:
   option legends and price deltas, the three sound tiles and the Compare sheet, proxy selects, the fit line states
   (SP.Garage, agreed with sp2-knownfit), gallery, zoom and Hear it, the build line dates, the sticky bar (driver rule
   356993e + fcf7ecf), the Low Rider ST row two-line add (agreed with sp2-drawer), the In your cart line.
   No /cart.js polling: cart state comes from the server render and the drawer's sp:cart:change event.
   Selectors are scoped to the section (round 2 selector hygiene rule).
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return window.SP && SP.money ? SP.money(c, true) : '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (e) { /* ignore */ }
  }
  function garage() { return window.SP && SP.Garage ? SP.Garage : null; }
  function isDealer() { return document.documentElement.classList.contains('sp-dealer') || !!(window.SP && SP.isDealer && SP.isDealer()); }
  var TICK = '<span class="sp-tick" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M20 6L9 17l-5-5"/></svg></span>';
  var ICONS = {
    target: '<circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/>',
    tick: '<path d="M20 6L9 17l-5-5"/>',
    warn: '<circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/>',
    bike: '<circle cx="5.5" cy="16.5" r="3"/><circle cx="18.5" cy="16.5" r="3"/><path d="M5.5 16.5l3-7h5l2 4h3M9 9.5l2-3h3"/>'
  };

  function profileOf(v) { v = String(v || '').toLowerCase(); return v.indexOf('balanced') > -1 ? 'Balanced' : v.indexOf('aggressive') > -1 ? 'Aggressive' : v.indexOf('extreme') > -1 ? 'Extreme' : ''; }
  /* Same display rules as snippets/sp-pdp-optlabel.liquid */
  function optLabel(value, role) {
    var v = String(value || '').trim(), vd = v.toLowerCase();
    if (role === 'badge') return vd.indexOf('custom') > -1 ? 'Custom' : (vd === 'yes' || vd.indexOf('stealth badge') > -1 ? 'Stealth' : 'No badge');
    if (role === 'muffler') return vd.indexOf('streetsweeper') > -1 ? 'Streetsweeper Turndown' : v.split(' (')[0].replace(/ muffler/i, '').trim();
    var name = v.indexOf(' (') > -1 ? v.split(' (')[0].trim() : v;
    if (name === name.toUpperCase() && name.length > 3) name = name.charAt(0) + name.slice(1).toLowerCase();
    return name;
  }

  /* ---------- Hear it player (HEAR-IT, 2026-10-09, HEAR-IT-STRATEGY.md 2) ----------
     One HTMLAudioElement for every [data-sp-clip] button on the page (the gallery button and the line under the muffler
     choice), so only one clip ever plays. It gets its src on the first tap (preload none, never autoplay), so no mp3
     loads before a tap. Another play, a muffler change (sp-pdp.js syncHear) or a hidden tab pauses it. While playing
     the button shows "Pause" and the pause icon, its name becomes "Pause the <muffler> sound" (stopped: "Hear the
     <muffler>. Play the sound, N seconds", which keeps the visible words, WCAG 2.5.3), and it fills an elapsed bar
     (--sp-clip-p). No aria-pressed: the name already says what a press does. */
  var Clip = (function () {
    var audio = null, owner = null;
    function paint(b, on, reset) {
      if (!b) return;
      /* the button keeps its width while it says "Pause", so the caption never reflows under it */
      if (on && !b.classList.contains('is-playing')) b.style.minWidth = b.getBoundingClientRect().width + 'px';
      if (!on) b.style.minWidth = '';
      b.classList.toggle('is-playing', on);
      var l = qs('[data-sp-clip-label]', b);
      if (l) l.textContent = on ? 'Pause' : (b.getAttribute('data-sp-clip-name') || l.textContent);
      var n = b.getAttribute(on ? 'data-sp-clip-pause' : 'data-sp-clip-play');
      if (n) b.setAttribute('aria-label', n);
      if (reset) b.style.setProperty('--sp-clip-p', '0');
    }
    function stop() { if (audio && !audio.paused) audio.pause(); }
    function ensure() {
      if (audio) return audio;
      audio = new Audio();
      audio.preload = 'none';
      audio.addEventListener('playing', function () { paint(owner, true); });
      audio.addEventListener('pause', function () { paint(owner, false); });
      audio.addEventListener('ended', function () { paint(owner, false, true); });
      audio.addEventListener('timeupdate', function () { if (owner && audio.duration) owner.style.setProperty('--sp-clip-p', String(Math.min(1, audio.currentTime / audio.duration))); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
      return audio;
    }
    function toggle(b, onPlay) {
      var src = b.getAttribute('data-src');
      if (!src) return;
      var a = ensure();
      if (owner === b && !a.paused) { a.pause(); return; }
      var fresh = owner !== b || a.getAttribute('src') !== src;
      if (owner && owner !== b) { a.pause(); paint(owner, false, true); }
      owner = b;
      if (a.getAttribute('src') !== src) a.setAttribute('src', src);
      if (fresh) { try { a.currentTime = 0; } catch (e) { /* not loaded yet */ } b.style.setProperty('--sp-clip-p', '0'); }
      var p = a.play();
      if (p && typeof p.then === 'function') p.then(function () { if (onPlay) onPlay(); }).catch(function () { paint(b, false); });
      else if (onPlay) onPlay();
    }
    function state() { return audio ? { src: audio.getAttribute('src') || '', paused: audio.paused, t: audio.currentTime } : null; }
    return { toggle: toggle, stop: stop, state: state };
  })();
  window.SP = window.SP || {};
  SP.Clip = Clip;

  function initSection(section) {
    if (!section || section.__spPdp) return;
    section.__spPdp = true;

    var productId = section.dataset.productId;
    var handle = section.dataset.productHandle;
    var variants = [];
    try { variants = JSON.parse(qs('[data-variant-json]', section).textContent); } catch (e) { variants = []; }
    var form = document.getElementById(section.dataset.formId);
    var atc = form ? qs('[data-add-to-cart]', form) : null;

    function priceOf(v) { return window.SP && SP.dealerPrice ? SP.dealerPrice(v.price, productId, v.id) : v.price; }
    function selected() {
      var out = {};
      qsa('[data-variant-input]', section).forEach(function (el) {
        var k = el.dataset.index; if (!k) return;
        if (el.tagName === 'SELECT') out[k] = el.value; else if (el.checked) out[k] = el.value;
      });
      return out;
    }
    function current() {
      var sel = selected();
      return variants.filter(function (v) { return Object.keys(sel).every(function (k) { return v[k] === sel[k]; }); })[0] || null;
    }
    /* the variant with this option value and every other option as selected now */
    function variantWith(key, value) {
      var sel = selected();
      return variants.filter(function (v) { return v[key] === value && Object.keys(sel).every(function (k) { return k === key || v[k] === sel[k]; }); })[0] || null;
    }
    function deltaText(v, cur) {
      if (!v) return '';
      if (!v.available) return 'Sold out';
      var a = priceOf(v), b = cur ? priceOf(cur) : null;
      if (a === null || b === null) return '';
      var d = a - b;
      return d > 0 ? '+' + money(d) : d < 0 ? '-' + money(-d) : 'Same price';
    }
    function radiosFor(key) { return qsa('input[data-variant-input][data-index="' + key + '"]', section); }
    function pick(key, value) {
      var r = radiosFor(key).filter(function (i) { return i.value === value; })[0];
      if (!r || r.checked) return false;
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    /* ---------- option legends, tile deltas, proxies ---------- */
    function syncTiles() {
      var cur = current();
      qsa('.sp-opt', section).forEach(function (wrap) {
        var role = wrap.dataset.spRole;
        var group = qs('.variant-input-wrap', wrap);
        if (!group) return;
        var key = group.dataset.index;
        var checked = qs('input[data-variant-input]:checked', group);
        var lv = qs('[data-sp-legend-value]', group);
        if (lv && checked) lv.textContent = optLabel(checked.value, role);
        qsa('[data-sp-delta]', group).forEach(function (d) {
          var val = d.getAttribute('data-value');
          if (checked && checked.value === val) { d.innerHTML = TICK.replace('sp-tick"', 'sp-tick sp-tick--corner"') + '<span class="visually-hidden">Selected</span>'; return; }
          d.textContent = deltaText(variantWith(key, val), cur);
        });
        var proxy = qs('[data-sp-proxy="' + key + '"]', wrap);
        if (proxy) {
          if (checked && proxy.value !== checked.value) proxy.value = checked.value;
          radiosFor(key).forEach(function (r) {
            var o = qsa('option', proxy).filter(function (x) { return x.value === r.value; })[0];
            if (o) { var so = r.classList.contains('disabled'); o.textContent = r.value + (so ? ' (sold out)' : ''); }
          });
        }
      });
    }
    section.addEventListener('change', function (e) {
      var p = e.target.closest('[data-sp-proxy]');
      if (!p || !section.contains(p)) return;
      pick(p.getAttribute('data-sp-proxy'), p.value);
    });

    /* ---------- sound step ---------- */
    var sound = qs('[data-sp-sound]', section);
    var mKey = sound ? sound.dataset.option : null;
    var RANKS = [/^reverse cone/i, /^pipe bomb/i, /turnout/i, /turndown|streetsweeper/i, /^mid-length/i, /^breacher/i, /^burner/i];
    function defaultFor(prof) {
      var vals = radiosFor(mKey).map(function (r) { return r.value; }).filter(function (v) { return profileOf(v) === prof; });
      for (var i = 0; i < RANKS.length; i++) { var hit = vals.filter(function (v) { return RANKS[i].test(v); })[0]; if (hit) return hit; }
      return vals[0] || '';
    }
    function syncSound() {
      if (!sound) return;
      var cur = current();
      var sel = (qs('input[data-variant-input][data-index="' + mKey + '"]:checked', section) || {}).value || '';
      var sp = profileOf(sel);
      qsa('[data-sp-sound-tile]', sound).forEach(function (t) {
        var prof = t.getAttribute('data-sp-sound-tile');
        var val = prof === sp ? sel : defaultFor(prof);
        var on = prof === sp;
        t.setAttribute('data-value', val);
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var n = qs('[data-sp-sound-name]', t); if (n) n.textContent = optLabel(val, 'muffler');
        var d = qs('[data-sp-sound-delta]', t);
        var v = variantWith(mKey, val);
        t.classList.toggle('is-sold', !!(v && !v.available));
        if (d) d.innerHTML = on ? TICK + '<span class="visually-hidden">Selected</span>' : esc(deltaText(v, cur));
      });
      var lv = qs('[data-sp-sound-value]', sound); if (lv) lv.textContent = sp + ' · ' + optLabel(sel, 'muffler');
      /* muffler cards: the selected profile's mufflers show, the rest stay hidden (their lazy photos never load) */
      var nVis = 0;
      qsa('[data-sp-sound-card]', sound).forEach(function (c) {
        var prof = c.getAttribute('data-sp-sound-card'), val = c.getAttribute('data-value');
        var show = prof === sp, on = val === sel;
        c.hidden = !show; if (show) nVis++;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.tabIndex = on ? 0 : -1;
        var v = variantWith(mKey, val);
        c.classList.toggle('is-sold', !!(v && !v.available));
        var d = qs('[data-sp-sound-delta]', c);
        if (d) d.innerHTML = on ? TICK + '<span class="visually-hidden">Selected</span>' : esc(deltaText(v, cur));
      });
      var ch = qs('[data-sp-cards-h]', sound); if (ch && sp) ch.textContent = sp + (nVis === 1 ? ' muffler' : ' mufflers') + ' (' + nVis + ')';
      var cw = qs('[data-sp-sound-cards]', sound); if (cw) cw.hidden = !sp || !nVis; /* a value with no profile word: no empty row */
      var cg = qs('.sp-mcards__grid', sound); if (cg) cg.style.setProperty('--sp-mc-n', String(Math.max(4, nVis)));
      qsa('[data-sp-quote]', section).forEach(function (q) { if (!q.closest('[data-sp-rung]')) q.hidden = q.getAttribute('data-sp-quote') !== sp; });
      /* ladder rows (page and sheet) */
      qsa('[data-sp-pick]').forEach(function (b) {
        if (!section.contains(b) && !b.closest('[data-sp-sheet]')) return;
        var on2 = b.getAttribute('data-sp-pick') === sel;
        b.classList.toggle('is-on', on2); b.setAttribute('aria-pressed', on2 ? 'true' : 'false');
        var pr = qs('[data-sp-row-price]', b);
        if (pr) { var vv = variantWith(mKey, b.getAttribute('data-sp-pick')); var p = vv ? priceOf(vv) : null; pr.textContent = !vv ? '' : !vv.available ? 'Sold out' : (p === null ? '' : money(p)); }
      });
      qsa('[data-sp-rung]').forEach(function (r) { if (section.contains(r) || r.closest('[data-sp-sheet]')) r.classList.toggle('is-on', r.getAttribute('data-sp-rung') === sp); });
      syncHear(sel);
    }
    if (sound) {
      sound.addEventListener('click', function (e) {
        var t = e.target.closest('[data-sp-sound-tile], [data-sp-sound-card]');
        if (!t) return;
        var isCard = t.hasAttribute('data-sp-sound-card');
        var prof = t.getAttribute(isCard ? 'data-sp-sound-card' : 'data-sp-sound-tile');
        if (pick(mKey, t.getAttribute('data-value'))) track('pdp_sound_pick', { profile: prof, muffler: t.getAttribute('data-value'), surface: isCard ? 'card' : 'tile' });
      });
      /* one keyboard model for both radiogroups: arrows move and select within the group, Home and End jump */
      sound.addEventListener('keydown', function (e) {
        var t = e.target.closest('[data-sp-sound-tile], [data-sp-sound-card]');
        if (!t || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(e.key) < 0) return;
        var isCard = t.hasAttribute('data-sp-sound-card');
        var items = qsa(isCard ? '[data-sp-sound-card]:not([hidden])' : '[data-sp-sound-tile]', sound), i = items.indexOf(t);
        if (i < 0) return;
        var n = e.key === 'Home' ? 0 : e.key === 'End' ? items.length - 1 : (i + ((e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 1) + items.length) % items.length;
        e.preventDefault();
        items[n].click(); items[n].focus();
      });
    }

    /* ---------- ladder rows and the Compare sheet ---------- */
    var sheet = qs('[data-sp-sheet]', section);
    var sheetOpener = null;
    function choose(value, surface) {
      if (!mKey) return;
      var changed = pick(mKey, value);
      if (changed) track('pdp_sound_pick', { profile: profileOf(value), muffler: value, surface: surface });
    }
    section.addEventListener('click', function (e) {
      var row = e.target.closest('[data-sp-pick]');
      if (row && !row.closest('[data-sp-sheet]')) {
        choose(row.getAttribute('data-sp-pick'), 'ladder');
        var on = sound && qs('[data-sp-sound-tile].is-on', sound);
        if (sound) sound.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        if (on) setTimeout(function () { on.focus({ preventScroll: true }); }, reduceMotion ? 0 : 400);
        return;
      }
      var cmp = e.target.closest('[data-sp-compare]');
      if (cmp && sheet && typeof sheet.showModal === 'function') {
        e.preventDefault();
        var grid = qs('[data-sp-ladder-grid]', section);
        var body = qs('[data-sp-sheet-body]', sheet);
        if (grid && body) {
          body.innerHTML = '';
          var clone = grid.cloneNode(true);
          qsa('[id]', clone).forEach(function (n) { n.removeAttribute('id'); });
          qsa('[data-shopify-editor-block]', clone).forEach(function (n) { n.removeAttribute('data-shopify-editor-block'); });
          /* The sheet carries no rider quotes (Ricky 2026-10-15); the on-page ladder keeps its own */
          qsa('[data-sp-quotes]', clone).forEach(function (n) { n.parentNode.removeChild(n); });
          body.appendChild(clone);
        }
        sheetOpener = cmp;
        sheet.showModal();
        document.body.classList.add('sp-sheet-open');
        var first = qs('.sp-mrow.is-on', sheet) || qs('.sp-mrow', sheet) || qs('[data-sp-sheet-close]', sheet);
        if (first) first.focus();
        track('pdp_compare_open', {});
      }
    });
    if (sheet) {
      var closeSheet = function () { if (sheet.open) sheet.close(); };
      sheet.addEventListener('close', function () { document.body.classList.remove('sp-sheet-open'); if (sheetOpener) sheetOpener.focus(); });
      sheet.addEventListener('click', function (e) {
        if (e.target === sheet || e.target.closest('[data-sp-sheet-close]')) { closeSheet(); return; }
        var row = e.target.closest('[data-sp-pick]');
        if (row) { choose(row.getAttribute('data-sp-pick'), 'sheet'); setTimeout(closeSheet, 120); }
      });
    }

    /* ---------- gallery, zoom, Hear it ---------- */
    var gal = qs('[data-sp-gal]', section);
    var track_ = gal ? qs('[data-product-photos]', gal) : null;
    var slides = track_ ? qsa('[data-sp-slide]', track_) : [];
    var idxEl = gal ? qs('[data-sp-gal-index]', gal) : null;
    var thumbs = gal ? qsa('[data-sp-thumb]', gal) : [];
    var curSlide = 0;
    /* R3-06: while a smooth scroll runs to slide seekTo, the observer ignores the slides it passes on the way, or
       fast arrow presses step from a stale slide. Cleared on arrival, after 1s, or when the rider scrolls the track. */
    var seekTo = -1, seekT = 0;
    function goSlide(i, smooth) {
      if (!track_ || !slides[i]) return;
      var sm = smooth && !reduceMotion;
      clearTimeout(seekT); seekTo = sm ? i : -1;
      if (sm) seekT = setTimeout(function () { seekTo = -1; }, 1000);
      track_.scrollTo({ left: slides[i].offsetLeft - track_.offsetLeft, behavior: sm ? 'smooth' : 'auto' });
    }
    /* QA 2026-10-12 (Ricky, item 3): a variant change or a far thumbnail used to smooth-scroll across every photo in
       between (36 on the M8 Softail). swipeTo jumps the track straight to the target, then the target photo plays a
       short entry: 32px in from the side it comes from with a light fade, 240ms on the token ease. An instant jump never
       puts a slide in between 60% in view, so the observer only ever counts the target; seekTo stays armed as the guard.
       Arrows stay native (goSlide smooth, one step) and finger or trackpad swipes are the browser's. Reduced motion:
       the jump alone. */
    var SWIPE_PX = 32, SWIPE_MS = 240;
    var swipeEase = (getComputedStyle(document.body).getPropertyValue('--sp-ease') || '').trim() || 'cubic-bezier(.2,.7,.2,1)';
    function swipeTo(i) {
      if (!track_ || !slides[i]) return;
      var from = curSlide;
      if (i === from) { goSlide(i, false); return; } /* already in view: settle it, no guard, no entry */
      clearTimeout(seekT); seekTo = i;
      seekT = setTimeout(function () { seekTo = -1; }, 1000);
      track_.scrollTo({ left: slides[i].offsetLeft - track_.offsetLeft, behavior: 'auto' });
      if (reduceMotion) return;
      var media = slides[i].firstElementChild;
      if (!media || typeof media.animate !== 'function') return;
      if (media._spSwipe) media._spSwipe.cancel();
      media._spSwipe = media.animate(
        [{ transform: 'translateX(' + (i > from ? SWIPE_PX : -SWIPE_PX) + 'px)', opacity: 0.5 }, { transform: 'translateX(0)', opacity: 1 }],
        { duration: SWIPE_MS, easing: swipeEase }
      );
      media._spSwipe.onfinish = media._spSwipe.oncancel = function () { media._spSwipe = null; };
    }
    /* R2A-05: only the slide in view keeps its Zoom button in the Tab order (98 stops to Add to cart at 1440); the
       thumbnails stay in order and move the view, which moves the stop. */
    function zoomTab(i) { slides.forEach(function (s, n) { var z = s.querySelector('[data-sp-zoom-open]'); if (z) z.tabIndex = n === i ? 0 : -1; }); }
    function setCur(i) {
      curSlide = i;
      zoomTab(i);
      if (idxEl) idxEl.textContent = String(i + 1);
      thumbs.forEach(function (t, n) { if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    if (track_ && slides.length > 1 && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting || en.intersectionRatio <= 0.6) return;
          var k = slides.indexOf(en.target);
          if (seekTo > -1 && k !== seekTo) return;
          if (k === seekTo) { seekTo = -1; clearTimeout(seekT); }
          setCur(k);
        });
      }, { root: track_, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
      ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) { track_.addEventListener(ev, function () { seekTo = -1; clearTimeout(seekT); }, { passive: true }); });
    }
    /* a thumbnail one step away scrolls as before; a farther one takes the short swipe (item 3) */
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { if (Math.abs(n - curSlide) > 1) swipeTo(n); else goSlide(n, true); setCur(n); }); });
    zoomTab(0);
    /* D19 (WCAG 2.4.7): arrows on a Zoom button move focus with the photo, so the ring stays on the slide in view and
       Enter zooms the photo shown. A video slide has no Zoom button: focus goes to its player. */
    if (track_) track_.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var n = e.key === 'ArrowRight' ? Math.min(curSlide + 1, slides.length - 1) : Math.max(curSlide - 1, 0);
      var a = document.activeElement;
      var onZoom = a && a.matches && a.matches('[data-sp-zoom-open]') && track_.contains(a);
      goSlide(n, true); setCur(n);
      if (!onZoom || !slides[n]) return;
      var to = slides[n].querySelector('[data-sp-zoom-open], video, iframe');
      if (to && to !== a) to.focus({ preventScroll: true });
    });
    /* the variant's photo (Impulse fires variantImageChange; its own handler finds no slider and stops) */
    section.addEventListener('variantImageChange', function (e) {
      var v = e.detail && e.detail.variant;
      var id = v && v.featured_media && v.featured_media.id;
      if (!id) return;
      var i = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(id));
      if (i > -1) { swipeTo(i); setCur(i); }
    });
    var zoom = qs('[data-sp-zoom]', section);
    var zoomAt = 0, zoomOpener = null;
    var zoomables = gal ? qsa('[data-sp-zoom-open]', gal) : [];
    function showZoom(i) {
      if (!zoom || !zoomables[i]) return;
      zoomAt = i;
      var img = qs('[data-sp-zoom-img]', zoom);
      var inner = qs('img', zoomables[i]);
      img.src = zoomables[i].getAttribute('data-full');
      img.alt = inner ? inner.alt : '';
      var c = qs('[data-sp-zoom-count]', zoom); if (c) c.textContent = (i + 1) + ' / ' + zoomables.length;
    }
    zoomables.forEach(function (b, i) {
      b.addEventListener('click', function () {
        if (!zoom || typeof zoom.showModal !== 'function') return;
        zoomOpener = b; showZoom(i); zoom.showModal(); track('pdp_gallery', { action: 'zoom' });
        var x = qs('[data-sp-zoom-close]', zoom); if (x) x.focus();
      });
    });
    if (zoom) {
      zoom.addEventListener('click', function (e) {
        if (e.target === zoom || e.target.closest('[data-sp-zoom-close]')) { zoom.close(); return; }
        var st = e.target.closest('[data-sp-zoom-step]');
        if (st) showZoom((zoomAt + parseInt(st.getAttribute('data-sp-zoom-step'), 10) + zoomables.length) % zoomables.length);
      });
      zoom.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') showZoom((zoomAt + 1) % zoomables.length);
        if (e.key === 'ArrowLeft') showZoom((zoomAt - 1 + zoomables.length) % zoomables.length);
      });
      /* D19: back on the Zoom that opened the viewer, with its photo in view. */
      zoom.addEventListener('close', function () {
        if (!zoomOpener) return;
        var k = slides.indexOf(zoomOpener.closest('[data-sp-slide]'));
        if (k > -1 && k !== curSlide) { goSlide(k, false); setCur(k); }
        zoomOpener.focus();
      });
    }
    /* Hear it (HEAR-IT, 2026-10-09): the gallery button and the line under the muffler choice (sp-pdp-hear) follow the
       muffler. Systems: the selected Muffler value through kit.mufflers[].match; slip-ons: their own handle. A muffler
       product's own custom.sound_clip wins (data-sp-clips, data-sp-clip-own). No clip, no button. Both play through
       SP.Clip, and a muffler change stops the clip. */
    var clipBtns = qsa('[data-sp-clip]', section);
    var hearLine = qs('[data-sp-hear-line]', section);
    var hearCap = hearLine ? qs('[data-sp-clip-cap]', hearLine) : null;
    var clips = {};
    try { clips = JSON.parse((gal && gal.getAttribute('data-sp-clips')) || '{}'); } catch (e) { clips = {}; }
    /* The line's caption and hint spans are gone (2026-10-15); when the button describes itself, share that with the
       gallery button, otherwise leave aria-describedby off (never the string "null" or stale ids) */
    if (hearLine) {
      var hearIds = qs('[data-sp-clip]', hearLine).getAttribute('aria-describedby');
      clipBtns.forEach(function (b) { if (!hearLine.contains(b)) { if (hearIds) b.setAttribute('aria-describedby', hearIds); else b.removeAttribute('aria-describedby'); } });
    }
    function clipFor(value) {
      var K = (window.SP_GARAGE_VOCAB && SP_GARAGE_VOCAB.kit && SP_GARAGE_VOCAB.kit.mufflers) || {};
      var h = '';
      if (mKey) Object.keys(K).forEach(function (k) { var m = K[k].match; if (!h && m && value && new RegExp(m, 'i').test(value)) h = k; });
      else if (K[handle]) h = handle;
      var own = mKey ? (h ? clips[h] : '') : (gal ? gal.getAttribute('data-sp-clip-own') : '');
      var e = h ? K[h] : null;
      var src = own || (e && e.clip) || '';
      if (!src) return null;
      return { src: src, name: e ? e.name : (mKey ? optLabel(value, 'muffler') : ''), profile: e ? e.profile : profileOf(value), sec: own ? 0 : (e.clipSec || 0) };
    }
    var hearVal = null;
    function syncHear(value) {
      if (!clipBtns.length) return;
      if (hearVal !== null && value !== hearVal) Clip.stop();
      hearVal = value;
      var c = clipFor(value);
      if (hearLine) hearLine.hidden = !c;
      clipBtns.forEach(function (b) {
        if (!hearLine || !hearLine.contains(b)) b.hidden = !c;
        if (!c) { b.removeAttribute('data-src'); return; }
        var idle = c.name ? 'Hear the ' + c.name : 'Hear it';
        var playing = b.classList.contains('is-playing');
        b.setAttribute('data-src', c.src);
        b.setAttribute('data-sp-clip-name', idle);
        b.setAttribute('data-sp-clip-play', idle + '. Play the sound' + (c.sec ? ', ' + c.sec + ' seconds' : ''));
        b.setAttribute('data-sp-clip-pause', c.name ? 'Pause the ' + c.name + ' sound' : 'Pause the sound');
        b.setAttribute('aria-label', b.getAttribute(playing ? 'data-sp-clip-pause' : 'data-sp-clip-play'));
        b.setAttribute('data-sp-clip-muffler', c.name);
        b.setAttribute('data-sp-clip-profile', c.profile);
        var l = qs('[data-sp-clip-label]', b);
        if (l && !playing) l.textContent = idle;
      });
      if (hearCap && c) { hearCap.textContent = c.sec ? 'Idle, then revs, ' + c.sec + ' s' : ''; hearCap.hidden = !c.sec; } /* no-op since 2026-10-15: the caption span is not rendered */
    }
    section.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sp-clip]');
      if (!b || !section.contains(b)) return;
      Clip.toggle(b, function () {
        var d = { muffler: b.getAttribute('data-sp-clip-muffler') || '', profile: b.getAttribute('data-sp-clip-profile') || '', product: handle, spot: b.getAttribute('data-sp-clip-spot') || '', src: b.getAttribute('data-src') };
        track('pdp_clip_play', d);
        try { var k = window.klaviyo || window._learnq; if (k && typeof k.push === 'function') k.push(['track', 'Played Sound Clip', { Muffler: d.muffler, Profile: d.profile, Product: d.product, Spot: d.spot }]); } catch (err) { /* ignore */ }
      });
    });

    /* ---------- At a glance rows ---------- */
    function syncGlance() {
      var sel = selected();
      var m = qs('[data-sp-glance="muffler"]', section);
      if (m && mKey && sel[mKey]) m.textContent = optLabel(sel[mKey], 'muffler') + ', ' + profileOf(sel[mKey]) + ' sound';
      var f = qs('[data-sp-glance="finish"]', section);
      if (f && sel[f.getAttribute('data-option')]) f.textContent = optLabel(sel[f.getAttribute('data-option')], 'finish');
    }

    /* ---------- build line dates (finish adders from the same settings as snippets/lead-time.liquid) ---------- */
    var build = qs('[data-sp-buildline][data-dyn]', section);
    function syncBuild() {
      if (!build) return;
      var lead = qs('[data-lead-time]', build), line = lead && qs('[data-lead-line]', lead);
      if (!lead || !line) return;
      var sel = selected();
      var finish = Object.keys(sel).map(function (k) { return sel[k]; }).join(' ').toLowerCase();
      var add = finish.indexOf('polish') > -1 ? parseInt(lead.dataset.polished, 10) || 0 : (finish.indexOf('cerakote') > -1 || finish.indexOf('black') > -1 ? parseInt(lead.dataset.cerakote, 10) || 0 : 0);
      var min = parseInt(lead.dataset.min, 10), max = parseInt(lead.dataset.max, 10);
      var now = Date.now(), wk = 604800000; /* D15: the browser's today, never a cached server time */
      var fmt = function (ms) { return new Date(ms).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
      var tpl = build.getAttribute('data-tpl') || '';
      if (!tpl || isNaN(min) || isNaN(max)) return;
      line.textContent = tpl.replace('[from]', fmt(now + (min + add) * wk)).replace('[to]', fmt(now + (max + add) * wk));
    }

    /* ---------- In your cart (no fetch: server render + the drawer's sp:cart:change) ---------- */
    var inCart = qs('[data-sp-incart]', section);
    var cartIds = String(section.dataset.cartIds || '').split(',').filter(Boolean);
    function syncInCart() {
      if (!inCart) return;
      var v = current();
      inCart.hidden = !(v && cartIds.indexOf(String(v.id)) > -1);
    }
    document.addEventListener('sp:cart:change', function (e) {
      var c = e.detail && e.detail.cart;
      if (!c || !c.items) return;
      cartIds = c.items.map(function (i) { return String(i.variant_id || i.id); });
      syncInCart();
    });
    section.addEventListener('click', function (e) {
      if (!e.target.closest('[data-sp-open-cart]')) return;
      if (document.querySelector('[data-sp-cd]')) { e.preventDefault(); document.dispatchEvent(new CustomEvent('cart:open')); }
    });

    /* ---------- sticky bar (driver rule 356993e + fcf7ecf, ported unchanged) ---------- */
    var bar = qs('[data-sp-sticky3]', section);
    var stockPipes = false, headersOk = false;
    if (bar) {
      document.body.appendChild(bar); /* fixed layer outside the section so no transform or overflow traps it */
      document.body.classList.add('sp-has-sticky');
      /* SP-69b: a jump link whose target is not on this page, or not shown, goes (Pan America has no Sound ladder) */
      qsa('.sp-sticky3__links a[href^="#"]', bar).forEach(function (a) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t || !t.getClientRects().length) a.remove();
      });
      var sPrice = qs('[data-sp-sticky-price]', bar), sSub = qs('[data-sp-sticky-sub]', bar), sBtn = qs('[data-sp-sticky-btn]', bar);
      var previewBar = document.getElementById('preview-bar-iframe');
      if (previewBar) bar.style.bottom = (previewBar.offsetHeight || 60) + 'px';
      var kitBtn = function () { return qs('#kit [data-sp-kit-add]', section); };
      var syncSticky = function () {
        var cur = current();
        var kb = stockPipes ? kitBtn() : null;
        if (kb) {
          var kp = qs('#kit .sp-kit__price', section);
          sPrice.textContent = kp ? kp.textContent : '';
          sSub.textContent = 'Full system with the ' + (section.dataset.productTitle || '').split(' 2.25')[0].split(' Slip')[0].split(' Muffler')[0];
          sBtn.textContent = 'Add the system'; sBtn.disabled = kb.disabled;
          bar.classList.add('is-kit');
          return;
        }
        bar.classList.remove('is-kit');
        if (!cur) return;
        var p = priceOf(cur);
        sPrice.textContent = p === null ? '' : money(p);
        if (section.dataset.universal !== 'true' || section.classList.contains('is-headers-ok')) {
          var sel = selected(), parts = [];
          qsa('.sp-opt', section).forEach(function (w) {
            var g = qs('.variant-input-wrap', w); if (!g || w.dataset.spRole === 'single') return;
            var v = sel[g.dataset.index]; if (!v) return;
            var role = w.dataset.spRole;
            parts.push(role === 'badge' ? optLabel(v, 'badge') + ' badge' : optLabel(v, role === 'muffler' ? 'muffler' : 'finish'));
          });
          sSub.textContent = parts.join(' · ');
        } else sSub.textContent = 'Bolts to a 2.25 inch header, not stock pipes';
        sBtn.disabled = !cur.available;
        sBtn.textContent = cur.available ? 'Add to cart' : 'Sold out';
      };
      bar.__sync = syncSticky;
      sBtn.addEventListener('click', function () {
        var kb = stockPipes ? kitBtn() : null;
        track('pdp_sticky_add', { kit: !!kb });
        (kb || atc) && (kb || atc).click();
      });
      var atcOut = false, footerIn = false, seen = false;
      var deskBar = window.matchMedia('(min-width: 990px)');
      var footerEl = document.querySelector('.site-footer');
      var applySticky = function () {
        var h = document.documentElement.classList, bd = document.body.classList;
        var overlay = h.contains('js-drawer-open') || h.contains('sp-nav-open') || bd.contains('sp-cd-open') || bd.contains('sp-garage-open') || bd.contains('sp-sheet-open');
        /* SP-69c: from 990px the bar sits under the stuck header, so it waits for the header to stick (a short laptop
           window starts with Add to cart below the fold, and the bar showed as a 33px slice under the unstuck header) */
        var show = atcOut && !footerIn && !overlay && (!deskBar.matches || h.contains('sp-hdr-stuck'));
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.inert = !show;
        if (show && !seen) { seen = true; track('pdp_sticky_view', {}); }
      };
      if (atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { en.forEach(function (x) { atcOut = !x.isIntersecting; }); applySticky(); }, { threshold: 0 }).observe(atc);
        if (footerEl) new IntersectionObserver(function (en) { en.forEach(function (x) { footerIn = x.isIntersecting; }); applySticky(); }, { threshold: 0 }).observe(footerEl);
      }
      new MutationObserver(applySticky).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      if (deskBar.addEventListener) deskBar.addEventListener('change', applySticky);
      new MutationObserver(applySticky).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('sp:dealer-ready', syncSticky);
      var kitHost = qs('#kit', section);
      if (kitHost && 'MutationObserver' in window) new MutationObserver(function () { syncSticky(); }).observe(kitHost, { childList: true, subtree: true });
    }

    /* ---------- fit line (SP.Garage, contract with sp2-knownfit 2026-10-03) ---------- */
    var fit = qs('[data-sp-fitline]', section);
    function fitHTML(f) {
      fit.classList.remove('is-fits', 'is-nofit', 'is-ask', 'is-info', 'no-sub');
      if (f.cls) fit.classList.add(f.cls);
      if (!f.sub && !f.acts) fit.classList.add('no-sub');
      var ico = qs('.sp-fitline__ico', fit); if (ico) ico.innerHTML = ICONS[f.icon || 'target'];
      var body = qs('[data-sp-fit-body]', fit);
      var html = '<p class="sp-fitline__text">' + f.text + '</p>' + (f.sub ? '<p class="sp-fitline__sub">' + f.sub + '</p>' : '');
      if (body.innerHTML !== html) body.innerHTML = html;
      var act = qs('[data-sp-fit-act]', fit);
      if (act) act.innerHTML = f.act || '';
      var acts = qs('[data-sp-fit-acts]', fit);
      if (f.acts) {
        if (!acts) { acts = document.createElement('div'); acts.className = 'sp-fitline__acts'; acts.setAttribute('data-sp-fit-acts', ''); fit.appendChild(acts); }
        acts.innerHTML = f.acts;
      } else if (acts) acts.remove();
    }
    function link(href, text) { return '<a class="sp-link" href="' + esc(href) + '">' + esc(text) + '</a>'; }
    function btn(attr, text) { return '<button type="button" class="sp-link" ' + attr + '>' + esc(text) + '</button>'; }
    var CHANGE = btn('data-sp-garage-open', 'Change');
    function shopText(url, lbl) { return /^\/products\//.test(url) ? 'See the system for my ' + lbl : 'Shop parts for my ' + lbl; }
    function renderFit() {
      if (!fit) return;
      var G = garage();
      var serverText = esc(fit.getAttribute('data-server-text') || ''), serverSub = esc(fit.getAttribute('data-server-sub') || '');
      var server = { text: serverText, sub: serverSub, icon: 'target', act: fit.getAttribute('data-state') === 'universal' ? link('#kit', 'On stock pipes?') : '<button type="button" class="btn btn--secondary btn--small" data-sp-garage-open>Check my bike</button>' };
      stockPipes = false; headersOk = false;
      if (!G || isDealer()) { if (isDealer()) server.act = ''; fitHTML(server); return finishFit(); }
      var type = fit.getAttribute('data-type') || '';
      var r = G.fits(handle, type) || { status: 'unknown' };
      var act = G.active(), list = G.list();
      var L = function (b) { return esc(G.label(b)); };
      var S = function (b) { return esc(G.short ? G.short(b) : G.label(b)); };
      var f = server;
      switch (r.status) {
        case 'fits':
          if (r.other) f = { cls: 'is-fits', icon: 'tick', text: 'Fits your ' + L(r.bike) + '.', sub: 'Your active bike is the ' + L(act) + '.', acts: btn('data-sp-set-active="' + esc(r.bike.id) + '"', 'Make the ' + (G.short ? G.short(r.bike) : G.label(r.bike)) + ' my active bike') };
          else f = { cls: 'is-fits', icon: 'tick', text: 'Fits your ' + L(r.bike) + '.', sub: list.length > 1 ? 'Checked against your ' + list.length + ' bikes.' : '', act: CHANGE };
          break;
        case 'no_fit':
          var u = G.shopUrl(act);
          f = { cls: 'is-nofit', icon: 'warn', text: 'Not built for your ' + L(act) + '.', sub: serverText, act: CHANGE, acts: link(u, shopText(u, G.label(act))) };
          break;
        case 'wrong_year':
          var u2 = G.shopUrl(r.bike);
          f = { cls: 'is-nofit', icon: 'warn', text: 'Not built for your ' + L(r.bike) + '.', sub: r.window ? 'Built for ' + r.window[0] + ' to ' + r.window[1] + '.' : serverText, act: CHANGE, acts: link(u2, 'See what fits my ' + G.label(r.bike)) };
          break;
        case 'universal':
          var b = r.bike || r.other;
          if (r.headerless && !r.other) {
            f = { cls: 'is-nofit', icon: 'warn', text: 'Does not fit your ' + L(r.headerless) + '.', sub: 'It bolts to a 2.25 inch header, not stock pipes, and we do not build a header for the ' + S(r.headerless) + '.', acts: link(G.shopUrl(r.headerless), 'Shop for my ' + G.label(r.headerless)) };
          } else if (r.notOffered && !r.other) {
            f = { cls: 'is-nofit', icon: 'warn', text: 'Not offered for your ' + L(r.notOffered) + '.', sub: 'This muffler is not built for the ' + S(r.notOffered) + ' header.', acts: link(G.shopUrl(r.notOffered), 'Shop for my ' + G.label(r.notOffered)) };
          } else if (b && !r.slipon) {
            /* header parts (heat shields, clamp, hooks): no slip-on question, just the header fit */
            f = { cls: 'is-fits', icon: 'tick', text: 'Fits the Stealth header on your ' + L(b) + '.', act: CHANGE };
          } else if (b) {
            var hv = b.headers;
            if (hv === 'stealth') headersOk = true;
            if (hv === 'stealth') f = { cls: 'is-fits', icon: 'tick', text: 'Fits the Stealth headers on your ' + L(b) + '.', act: btn('data-sp-headers="" data-bike="' + esc(b.id) + '"', 'Change') };
            else if (hv === 'stock') { stockPipes = true; f = { cls: 'is-info', icon: 'target', text: 'Your ' + L(b) + ' is on stock pipes.', sub: 'This muffler does not bolt to stock pipes. The full system below comes with it on.', acts: link('#kit', 'See the full system') + btn('data-sp-headers="stealth" data-bike="' + esc(b.id) + '"', 'I have Stealth headers') }; }
            else f = { cls: 'is-ask', icon: 'bike', text: 'Your ' + L(b) + ': Stealth headers or stock pipes?', sub: 'This muffler bolts to a Stealth or other 2.25 inch header, not stock pipes.', acts: '<button type="button" class="btn btn--secondary btn--small" data-sp-headers="stealth" data-bike="' + esc(b.id) + '">Stealth headers</button><button type="button" class="btn btn--secondary btn--small" data-sp-headers="stock" data-bike="' + esc(b.id) + '">Stock pipes</button>' };
          }
          break;
        case 'model':
          var mg = qsa('.sp-opt', section).filter(function (w) { var g = qs('.variant-input-wrap', w); return g && /^model/.test(g.dataset.handle || ''); })[0];
          var mkey = mg ? qs('.variant-input-wrap', mg).dataset.index : null;
          var selv = mkey ? selected()[mkey] : '';
          var mf = typeof G.modelFit === 'function' ? G.modelFit(handle, selv) : null;
          if (mf && mf.state === 'fits') f = { cls: 'is-fits', icon: 'tick', text: 'Fits your ' + L(mf.bike) + '.', sub: 'Model ' + esc(mf.wantValue) + ' is selected for it.', act: CHANGE };
          else if (mf && mf.state === 'other_model') f = { cls: 'is-nofit', icon: 'warn', text: 'This Model is for ' + esc(selv) + '.', sub: 'Not your ' + L(mf.bike) + '.', acts: btn('data-sp-pick-model="' + esc(mf.wantValue) + '" data-key="' + esc(mkey) + '"', 'Select ' + mf.wantValue) };
          else if (mf && mf.state === 'not_made') f = { cls: 'is-nofit', icon: 'warn', text: 'We do not make this one for your ' + L(mf.bike) + '.', acts: link(G.shopUrl(mf.bike), 'Shop parts for my ' + G.label(mf.bike)) };
          break;
        default:
          break;
      }
      fitHTML(f);
      track('pdp_fit_state', { state: r.status, bikes: list.length });
      finishFit();
    }
    function finishFit() {
      section.classList.toggle('is-stock', stockPipes);
      section.classList.toggle('is-headers-ok', headersOk);
      if (bar && bar.__sync) bar.__sync();
    }
    if (fit) {
      fit.addEventListener('click', function (e) {
        var G = garage();
        var h = e.target.closest('[data-sp-headers]');
        if (h && G && typeof G.setHeaders === 'function') {
          var v = h.getAttribute('data-sp-headers') || null;
          G.setHeaders(h.getAttribute('data-bike'), v);
          track('pdp_headers_answer', { value: v || 'reset' });
          setTimeout(function () { fit.focus({ preventScroll: true }); }, 0);
          return;
        }
        var pm = e.target.closest('[data-sp-pick-model]');
        if (pm) { pick(pm.getAttribute('data-key'), pm.getAttribute('data-sp-pick-model')); track('pdp_fit_recovery', { action: 'pick_model' }); return; }
        var a = e.target.closest('a, button');
        if (a) track('pdp_fit_recovery', { action: a.getAttribute('data-sp-set-active') ? 'set_active' : (a.hasAttribute('data-sp-garage-open') ? 'change_bike' : 'shop') });
      });
    }

    /* ---------- Low Rider ST row (sp2-drawer A1 data row) ---------- */
    var rowData = qs('[data-up-row]', section);
    var rowEl = null, rowBox = null;
    function renderRow() {
      if (!rowData) return;
      var G = garage(), b = G ? G.active() : null;
      var model = b && b.genId === 'softail-m8' ? b.model : null;
      var want = rowData.getAttribute('data-up-model') || 'low-rider-st';
      if (!rowEl) rowEl = qs('[data-sp-addrow]', section);
      if (rowEl && !rowBox) { rowBox = qs('[data-sp-addrow-box]', rowEl); rowBox.addEventListener('change', function () { track('pdp_bracket_tick', { on: rowBox.checked }); }); }
      if (!rowEl) {
        rowEl = document.createElement('label');
        rowEl.className = 'sp-check-row sp-addrow text-label';
        rowEl.innerHTML = '<input type="checkbox" class="sp-check" data-sp-addrow-box><span class="sp-addrow__label"><span data-sp-addrow-label></span><small data-sp-addrow-help></small></span><span class="sp-addrow__price"></span>';
        rowData.parentNode.insertBefore(rowEl, rowData);
        rowBox = qs('[data-sp-addrow-box]', rowEl);
        rowBox.addEventListener('change', function () { track('pdp_bracket_tick', { on: rowBox.checked }); });
      }
      var hide = model && model !== want;
      rowEl.hidden = !!hide;
      if (hide) rowBox.checked = false;
      var sell = model === want && b;
      qs('[data-sp-addrow-label]', rowEl).textContent = sell ? (rowData.getAttribute('data-up-label-sell') || '').replace('{bike}', G.label(b)) : rowData.getAttribute('data-up-label-ask');
      qs('[data-sp-addrow-help]', rowEl).textContent = rowData.getAttribute('data-up-help') || '';
      var p = parseInt(rowData.getAttribute('data-up-price'), 10);
      var dp = window.SP && SP.dealerPrice ? SP.dealerPrice(p, null, rowData.getAttribute('data-up-variant')) : p;
      qs('.sp-addrow__price', rowEl).textContent = dp === null ? '' : '+' + money(dp);
    }
    if (form) form.addEventListener('ajaxProduct:added', function (e) {
      if (!rowBox || !rowBox.checked || rowEl.hidden || !(e.detail && e.detail.product)) return;
      var id = rowData.getAttribute('data-up-variant');
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'sp-cart-drawer' }) })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.status && d.status !== 200) throw new Error(d.description || 'add failed');
          rowBox.checked = false;
          document.dispatchEvent(new CustomEvent('sp:cart:render', { detail: { sections: d.sections || {}, src: (rowData.getAttribute('data-up-src') || 'bracket') + '@pdp' } }));
          track('pdp_bracket_add', {});
        })
        .catch(function () { /* the system is in the cart; the drawer still offers the bracket card */ });
    });

    /* ---------- Custom Badge notes behind a link (same inputs and gate, assets/custom-badge.js) ---------- */
    qsa('[data-custom-badge]', section).forEach(function (panel) {
      var lab = qs('.custom-badge__label', panel), notes = qs('[data-custom-badge-notes]', panel);
      if (!lab || !notes || panel.__spNotes) return;
      panel.__spNotes = true;
      var holder = document.createElement('div'); holder.className = 'sp-cb-notes'; holder.hidden = !notes.value;
      lab.parentNode.insertBefore(holder, lab); holder.appendChild(lab); holder.appendChild(notes);
      var t = document.createElement('button'); t.type = 'button'; t.className = 'sp-link sp-cb-notes__toggle'; t.textContent = 'Add a note for the shop';
      t.setAttribute('aria-expanded', holder.hidden ? 'false' : 'true');
      t.hidden = !holder.hidden;
      holder.parentNode.insertBefore(t, holder);
      t.addEventListener('click', function () { holder.hidden = false; t.hidden = true; t.setAttribute('aria-expanded', 'true'); notes.focus(); });
    });

    /* ---------- companion card (sp2-drawer) ---------- */
    var comp = qs('.sp-pdp__companion', section);
    if (comp && window.SP && SP.Upsell && typeof SP.Upsell.mount === 'function') SP.Upsell.mount(comp, { surface: 'pdp' });

    /* ---------- wiring ---------- */
    function markDealerPriced() {
      if (isDealer() && window.SP && SP.dealerPrice && variants[0] && SP.dealerPrice(variants[0].price, productId, variants[0].id) !== null) document.documentElement.classList.add('sp-dealer-priced');
    }
    /* Finish and Badge boxes one height (Ricky 2026-10-15): both groups' boxes measured at their natural height, the
       tallest written to --sp-optbox-h on the options wrap (the CSS min-height reads it). Again after fonts, on resize
       and on every variant change, because the price line can rewrap. */
    var optsWrap = qs('.sp-pdp__options', section), optsTimer;
    function equalizeOptBoxes() {
      if (!optsWrap) return;
      var tiles = qsa('.sp-tiles--finish .sp-tile, .sp-tiles--badge .sp-tile', optsWrap);
      if (tiles.length < 2) { optsWrap.style.removeProperty('--sp-optbox-h'); return; }
      optsWrap.style.setProperty('--sp-optbox-h', '0px');
      var h = 0;
      tiles.forEach(function (t) { h = Math.max(h, t.getBoundingClientRect().height); });
      optsWrap.style.setProperty('--sp-optbox-h', Math.ceil(h) + 'px');
    }
    function equalizeSoon() { clearTimeout(optsTimer); optsTimer = setTimeout(equalizeOptBoxes, 60); }
    window.addEventListener('resize', equalizeSoon);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalizeSoon);
    function syncAll() { markDealerPriced(); syncTiles(); syncSound(); if (!sound) syncHear(); syncGlance(); syncBuild(); syncInCart(); if (bar && bar.__sync) bar.__sync(); if (fit && fit.getAttribute('data-state') === 'model') renderFit(); equalizeOptBoxes(); }
    section.addEventListener('variantChange', function () { setTimeout(syncAll, 0); });
    section.addEventListener('change', function (e) { if (e.target.matches('[data-variant-input]')) setTimeout(syncAll, 0); });
    document.addEventListener('sp:dealer-ready', syncAll);
    /* SP.Garage.onChange fires on every garage write (add, remove, active, model, headers) */
    var G0 = garage();
    if (G0 && typeof G0.onChange === 'function') G0.onChange(function () { renderFit(); renderRow(); });
    renderFit();
    renderRow();
    syncAll();
    /* Deep link from the sound profile ladders (sp-coll-ladder.liquid, stealth-garage.js renderProfileCtas):
       ?sp_muffler=<value>#sp-muffler selects that muffler through the same radio a tile tap uses, so price, deltas,
       build dates, gallery and the lit tile follow. Values are the vocab's profileDefault ('^reverse cone') or a
       muffler's short name ('Reverse Cone'). Matched as text (a leading ^ means starts with), never compiled from the
       URL. The selected muffler always has a tile, so nothing needs opening. */
    (function () {
      if (!mKey) return;
      var want = '';
      try { want = (new URLSearchParams(window.location.search).get('sp_muffler') || '').trim().toLowerCase().slice(0, 80); } catch (e) { return; }
      if (!want) return;
      var start = want.charAt(0) === '^';
      if (start) want = want.slice(1);
      if (!want) return;
      var hit = radiosFor(mKey).map(function (r) { return r.value; }).filter(function (v) {
        var s = v.toLowerCase();
        return start ? s.indexOf(want) === 0 : s.indexOf(want) > -1;
      })[0];
      if (!hit) return;
      if (pick(mKey, hit)) track('pdp_sound_pick', { profile: profileOf(hit), muffler: hit, surface: 'deeplink' });
      var step = document.getElementById('sp-muffler');
      if (step) setTimeout(function () { step.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }, reduceMotion ? 0 : 300);
    })();
    /* the Tuning "Why" link opens its accordion */
    section.addEventListener('click', function (e) {
      var w = e.target.closest('[data-sp-open-acc]'); if (!w) return;
      var tgt = document.querySelector(w.getAttribute('href'));
      var trig = tgt && qs('.collapsible-trigger', tgt);
      if (trig && !trig.classList.contains('is-open')) trig.click();
    });
  }

  function boot() { qsa('[data-sp-pdp3]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ---------- related row (sections/sp-pdp-related.liquid), fetched once the page is idle ---------- */
(function () {
  'use strict';
  function load(host) {
    if (!host || host.__spLoaded || !host.dataset.url) return;
    host.__spLoaded = true;
    fetch(host.dataset.url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-sp-related]');
        if (!fresh || !fresh.querySelector('[data-product-handle]')) { host.hidden = true; return; }
        host.innerHTML = fresh.innerHTML;
        var root = host.querySelector('[data-sp-kf="pdp_related"]') || host;
        if (window.SP && SP.repriceDealer) SP.repriceDealer(root);
        document.dispatchEvent(new CustomEvent('sp:related:ready', { detail: { root: root } }));
      })
      .catch(function () { host.hidden = true; });
  }
  function boot() {
    var hosts = Array.prototype.slice.call(document.querySelectorAll('[data-sp-related][data-url]'));
    if (!hosts.length) return;
    var go = function () { hosts.forEach(load); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { io.unobserve(x.target); load(x.target); } }); }, { rootMargin: '800px 0px' });
      hosts.forEach(function (h) { io.observe(h); });
    }
    /* D21b (R4-02): also fill the row once the page is idle after load, so it does not land above a control a keyboard
       user just tabbed to. load() runs once per host, whichever path gets there first. */
    var idle = function () { if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 1500 }); else setTimeout(go, 1500); };
    if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
    document.addEventListener('sp:dealer-ready', function () { hosts.forEach(function (h) { if (window.SP && SP.repriceDealer) SP.repriceDealer(h); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
